import gql from "graphql-tag";

const RiskMatrixProps = gql`
    fragment RiskMatrixProps on Risk {
        id
        comment
        created_at
        author {
            id
            surname
            first_name
            middle_name
            designation {
                id
                name
            }
        }
        assessments {
            historical
            key
            value
        }
    }
`;

export const NEW_RISK_MATRIX = gql`
    mutation NewRiskMatrix($model: RiskMatrixInput!) {
        NewRisk(model: $model) {
            message
            doc {
                ...RiskMatrixProps
            }
        }
    }
    ${RiskMatrixProps}
`;

export const GET_RISK_MATRIX = gql`
    query GetRiskMatrix($patient: ID!) {
        GetRisks(patient: $patient) {
            docs {
                ...RiskMatrixProps
            }
        }
    }
    ${RiskMatrixProps}
`;
